import { render, staticRenderFns } from "./DeviceReportMultiplier.vue?vue&type=template&id=22c670ac&scoped=true"
import script from "./DeviceReportMultiplier.vue?vue&type=script&lang=js"
export * from "./DeviceReportMultiplier.vue?vue&type=script&lang=js"
import style0 from "./DeviceReportMultiplier.vue?vue&type=style&index=0&id=22c670ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c670ac",
  null
  
)

export default component.exports